import { ReduxListener } from '../../../types';

import initialize from './initialize';
import query from './query';
import statusCheck from './statusCheck';

const setupListeners = (startListening: ReduxListener) =>
  [initialize, query, statusCheck].forEach(listener =>
    listener(startListening),
  );

export default setupListeners;
